/* Заголовок экрана в верхней панели. Отдельный модуль, чтобы экраны не импортировали каркас (Shell) — без циклов. */
import { createContext, useContext, useEffect } from "react";

export interface TitleState {
  title: string;
  sub: string;
}

export const TitleCtx = createContext<(t: TitleState) => void>(() => undefined);

/** Экран сообщает каркасу свой заголовок и подзаголовок. */
export function useScreenTitle(title: string, sub = ""): void {
  const set = useContext(TitleCtx);
  useEffect(() => {
    set({ title, sub });
    document.title = title + " — Окно CRM";
  }, [set, title, sub]);
}
